import { useState, useEffect, useRef, useCallback } from "react";

// ── DATOS INICIALES ──────────────────────────────────────────────
const VENDEDORES = [
  { id: "admin", nombre: "Admin",   pin: "1234", rol: "admin"    },
  { id: "v1",    nombre: "Eitán",   pin: "1122", rol: "vendedor" },
  { id: "v2",    nombre: "Agustín", pin: "1133", rol: "vendedor" },
];

const REGIONES_INICIALES = ["CABA", "Córdoba", "Rosario", "Mendoza", "Santa Fe"];
const EMPRESAS_CAPTIO = ["Todas", "QZ SRL", "QZ Low Cost", "Air Quality"];

const COLUMNAS = [
  { id: "Nuevo",     label: "Nuevo",     color: "#6B7280", bg: "rgba(107,114,128,0.10)" },
  { id: "Validado",  label: "Validado",  color: "#3B82F6", bg: "rgba(59,130,246,0.10)"  },
  { id: "Cotizado",  label: "Cotizado",  color: "#F59E0B", bg: "rgba(245,158,11,0.10)"  },
  { id: "Ganado",    label: "Ganado",    color: "#10B981", bg: "rgba(16,185,129,0.10)"  },
  { id: "Perdido",   label: "Perdido",   color: "#EF4444", bg: "rgba(239,68,68,0.10)"   },
];

const FUENTE_ICON = {
  "Google Maps": "📍", "Páginas Amarillas": "📋", "Guía Oleo": "📋",
  "Cylex": "📋", "SerpAPI": "🔍", "Formulario Shopify": "🛍️",
  "Manual": "📁", "Google Places": "🗺️",
};

const LEADS_DEMO = [
  { id:1,  empresa:"Constructora Palermo SA",    contacto:"Ing. Martín Suárez",  cargo:"Gerente de Compras",  email:"msuarez@palermo.com.ar",   tel:"+54 9 351 412-3344", ciudad:"Córdoba",       region:"Córdoba",  segmento:"Construcción",  fuente:"Páginas Amarillas", estado:"Nuevo",    vendedor:"v1", score:93, monto:0,    fecha:"2026-05-10", notas:"Interesado en soluciones de gestión" },
  { id:2,  empresa:"TechSoft Rosario SRL",       contacto:"Ana Villarreal",       cargo:"CEO",                 email:"avillarreal@techsoft.com.ar",tel:"+54 9 341 223-4455", ciudad:"Rosario",       region:"Rosario",  segmento:"IT",            fuente:"SerpAPI",           estado:"Validado", vendedor:"v2", score:95, monto:0,    fecha:"2026-05-12", notas:"Muy abierto a propuestas" },
  { id:3,  empresa:"Logística Express SA",        contacto:"Pedro Romero",         cargo:"Jefe de Operaciones", email:"promero@logexpress.com.ar", tel:"+54 9 11 4422-8800", ciudad:"Buenos Aires",  region:"CABA",     segmento:"Logística",     fuente:"Formulario Shopify",estado:"Validado", vendedor:"v1", score:79, monto:0,    fecha:"2026-05-14", notas:"Pidió cotización por email" },
  { id:4,  empresa:"Metalúrgica San Martín SRL", contacto:"Eduardo Quiroga",      cargo:"Gerente Industrial",  email:"equiroga@metalusan.com.ar", tel:"+54 9 351 900-1122", ciudad:"Córdoba",       region:"Córdoba",  segmento:"Industrial",    fuente:"Cylex",             estado:"Cotizado", vendedor:"v2", score:90, monto:180000, fecha:"2026-05-08", notas:"Licitación en curso" },
  { id:5,  empresa:"Inmobiliaria Del Lago",       contacto:"Luis Carbajal",        cargo:"Gerente Comercial",   email:"lcarbajal@dellago.com.ar",  tel:"+54 9 299 112-3344", ciudad:"Rosario",       region:"Rosario",  segmento:"Inmobiliaria",  fuente:"Manual",            estado:"Ganado",   vendedor:"v3", score:82, monto:250000, fecha:"2026-05-06", notas:"Cierre exitoso" },
  { id:6,  empresa:"Distribuidora Rápida SA",     contacto:"Mónica Saavedra",      cargo:"Gerente de Ventas",   email:"msaavedra@distrap.com.ar",  tel:"+54 9 381 445-6677", ciudad:"Santa Fe",      region:"Santa Fe", segmento:"Distribución",  fuente:"Guía Oleo",         estado:"Perdido",  vendedor:"v1", score:74, monto:95000,  fecha:"2026-05-04", notas:"Eligió otro proveedor" },
  { id:7,  empresa:"Estudio Contable Del Valle",  contacto:"Cra. Patricia Molina", cargo:"Socia",               email:"pmolina@contable.com.ar",   tel:"+54 9 261 778-9900", ciudad:"Mendoza",       region:"Córdoba",  segmento:"Finanzas",      fuente:"Páginas Amarillas", estado:"Nuevo",    vendedor:"v3", score:68, monto:0,    fecha:"2026-05-16", notas:"" },
  { id:8,  empresa:"Marketing & Co Argentina",    contacto:"Valentina Torres",     cargo:"Directora",           email:"vtorres@marketingco.com.ar",tel:"+54 9 11 6655-4433", ciudad:"Buenos Aires",  region:"CABA",     segmento:"Marketing",     fuente:"Formulario Shopify",estado:"Validado", vendedor:"v2", score:91, monto:0,    fecha:"2026-05-18", notas:"Completó form esta semana" },
  { id:9,  empresa:"Agro Pampa SRL",              contacto:"Carlos Benitez",       cargo:"Dueño",               email:"cbenitez@agropampa.com.ar", tel:"+54 9 260 341-9988", ciudad:"Santa Fe",      region:"Santa Fe", segmento:"Agro",          fuente:"SerpAPI",           estado:"Cotizado", vendedor:"v3", score:86, monto:120000, fecha:"2026-05-09", notas:"Requiere demo" },
  { id:10, empresa:"Ferretería Industrial Paz",   contacto:"Gustavo Paz",          cargo:"Dueño",               email:"gpaz@ferind.com.ar",        tel:"+54 9 221 334-5566", ciudad:"Rosario",       region:"Rosario",  segmento:"Industrial",    fuente:"Guía Oleo",         estado:"Nuevo",    vendedor:"v1", score:88, monto:0,    fecha:"2026-05-19", notas:"Busca proveedor a largo plazo" },
];

// ── HELPERS ──────────────────────────────────────────────────────
const fmt$ = v => v ? `$${Number(v).toLocaleString("es-AR")}` : "—";
const scoreColor = s => s >= 85 ? "#10B981" : s >= 68 ? "#F59E0B" : "#EF4444";

function useLocalStorage(key, initial) {
  const [val, setVal] = useState(() => {
    try { const s = localStorage.getItem(key); return s ? JSON.parse(s) : initial; }
    catch { return initial; }
  });
  useEffect(() => { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} }, [key, val]);
  return [val, setVal];
}

// Hook para cargar leads reales — siempre pisa los datos demo
function useLeadsFromFile(setLeads) {
  useEffect(() => {
    fetch("https://qzsrl.velqo.io/api/leads")
      .then(r => {
        if (!r.ok) throw new Error("Sin servidor");
        return r.json();
      })
      .then(data => {
        if (!Array.isArray(data) || data.length === 0) return;
        const normalized = data.map((l, i) => ({
          id:       l.id || i + 1,
          empresa:  l.empresa || "",
          contacto: l.contacto || l.nombre_contacto || "",
          cargo:    l.cargo_decisor || l.cargo || "",
          email:    l.email_estimado || l.email || "",
          tel:      l.telefono || l.tel || "",
          ciudad:   l.ciudad || "",
          region:   l.region || "CABA",
          segmento: l.segmento || "",
          fuente:   l.fuente || "Agente IA",
          estado:   l.estado || "Nuevo",
          vendedor: l.vendedor || "",
          score:    Number(l.score) || 70,
          monto:    Number(l.monto) || 0,
          fecha:    l.fecha || new Date().toISOString().split("T")[0],
          notas:          l.notas || "",
          empresa_captio: l.empresa_captio || "QZ SRL",
        }));
        // Limpiar localStorage y setear datos reales
        localStorage.removeItem("qz_leads");
        setLeads(normalized);
      })
      .catch(err => {
        console.warn("Server no disponible, usando datos locales:", err);
      });
  }, []);
}

// ── COMPONENTES BASE ─────────────────────────────────────────────
function ScoreBar({ score }) {
  const c = scoreColor(score);
  return (
    <div style={{ display:"flex", alignItems:"center", gap:6 }}>
      <div style={{ flex:1, height:3, background:"rgba(255,255,255,0.08)", borderRadius:2, overflow:"hidden" }}>
        <div style={{ width:`${score}%`, height:"100%", background:c, borderRadius:2 }}/>
      </div>
      <span style={{ fontSize:10, color:c, fontWeight:700, minWidth:22 }}>{score}</span>
    </div>
  );
}

// ── MODAL MOVER LEAD ─────────────────────────────────────────────
function ModalMover({ lead, destino, onConfirm, onCancel }) {
  const [monto, setMonto] = useState(lead.monto || "");
  const [motivo, setMotivo] = useState("");

  const necesitaMonto  = destino === "Cotizado" || destino === "Ganado";
  const necesitaMotivo = destino === "Perdido";

  return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(0,0,0,0.7)",
      display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:16,
    }}>
      <div style={{
        background:"#111827", border:"1px solid rgba(255,255,255,0.1)",
        borderRadius:16, padding:28, width:"100%", maxWidth:400,
      }}>
        <div style={{ fontSize:16, fontWeight:700, color:"#fff", marginBottom:6 }}>
          Mover a <span style={{ color: COLUMNAS.find(c=>c.id===destino)?.color }}>{destino}</span>
        </div>
        <div style={{ fontSize:13, color:"rgba(255,255,255,0.5)", marginBottom:20 }}>
          {lead.empresa}
        </div>

        {necesitaMonto && (
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:"rgba(255,255,255,0.4)", textTransform:"uppercase", letterSpacing:1 }}>
              {destino === "Cotizado" ? "Monto del presupuesto (ARS)" : "Monto del cierre (ARS)"}
            </label>
            <input
              type="number"
              value={monto}
              onChange={e => setMonto(e.target.value)}
              placeholder="ej: 150000"
              style={{
                width:"100%", marginTop:6, background:"rgba(255,255,255,0.06)",
                border:"1px solid rgba(255,255,255,0.12)", borderRadius:8,
                padding:"10px 14px", color:"#fff", fontSize:14, outline:"none", boxSizing:"border-box",
              }}
            />
          </div>
        )}

        {necesitaMotivo && (
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:"rgba(255,255,255,0.4)", textTransform:"uppercase", letterSpacing:1 }}>
              Motivo de pérdida
            </label>
            <select
              value={motivo}
              onChange={e => setMotivo(e.target.value)}
              style={{
                width:"100%", marginTop:6, background:"#1F2937",
                border:"1px solid rgba(255,255,255,0.12)", borderRadius:8,
                padding:"10px 14px", color:"#fff", fontSize:13, outline:"none", boxSizing:"border-box",
              }}
            >
              <option value="">Seleccionar motivo...</option>
              <option value="Precio">Precio — eligió otro proveedor más barato</option>
              <option value="Sin respuesta">Sin respuesta — no contestó</option>
              <option value="No calificó">No calificó — no era el perfil</option>
              <option value="Competencia">Competencia — eligió competidor</option>
              <option value="Postergado">Postergado — no es el momento</option>
              <option value="Otro">Otro motivo</option>
            </select>
          </div>
        )}

        <div style={{ display:"flex", gap:10, marginTop:8 }}>
          <button onClick={onCancel} style={{
            flex:1, padding:"10px 0", borderRadius:8, border:"1px solid rgba(255,255,255,0.1)",
            background:"transparent", color:"rgba(255,255,255,0.5)", cursor:"pointer", fontSize:13,
          }}>Cancelar</button>
          <button
            onClick={() => onConfirm({ monto: Number(monto) || 0, motivo })}
            disabled={necesitaMotivo && !motivo}
            style={{
              flex:2, padding:"10px 0", borderRadius:8, border:"none",
              background: COLUMNAS.find(c=>c.id===destino)?.color || "#FF6B00",
              color:"#fff", cursor:"pointer", fontSize:13, fontWeight:700,
              opacity: (necesitaMotivo && !motivo) ? 0.4 : 1,
            }}
          >Confirmar</button>
        </div>
      </div>
    </div>
  );
}

// ── MODAL DETALLE LEAD ───────────────────────────────────────────
function ModalDetalle({ lead, vendedores, onClose, onAsignar, esAdmin, usuarioActual }) {
  const [mostrarPresupuesto, setMostrarPresupuesto] = useState(false);
  const [descPresupuesto, setDescPresupuesto]       = useState("");
  const [montoNeto, setMontoNeto]                   = useState("");
  const [generando, setGenerando]                   = useState(false);
  const [pdfResult, setPdfResult]                   = useState(null);
  const [enviandoEmail, setEnviandoEmail]           = useState(null); // "presentacion" | "5preguntas" | null
  const [emailLog, setEmailLog]                     = useState([]);
  const [loadingLog, setLoadingLog]                 = useState(false);

  const empKey = {
    "QZ SRL":      "qzsrl",
    "QZ Low Cost": "lowcost",
    "Air Quality": "airquality",
  }[lead.empresa_captio] || "qzsrl";

  const vendedor = vendedores.find(v => v.id === lead.vendedor);

  // Cargar historial de emails de este lead al abrir el modal
  useEffect(() => {
    setLoadingLog(true);
    fetch(`https://qzsrl.velqo.io/api/actividad?lead_id=${lead.id}&limit=20`)
      .then(r => r.json())
      .then(data => { setEmailLog(Array.isArray(data) ? data : []); setLoadingLog(false); })
      .catch(() => setLoadingLog(false));
  }, [lead.id]);

  const enviarEmail = (tipo) => {
    const labels = { presentacion: "email de presentación", "5preguntas": "email con 5 preguntas" };
    if (!window.confirm(`¿Confirmar envío de ${labels[tipo]} a ${lead.empresa}?`)) return;
    setEnviandoEmail(tipo);
    fetch(`https://qzsrl.velqo.io/api/email/${tipo}/${empKey}/${lead.id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ enviado_por: usuarioActual?.id || "sistema" }),
    })
    .then(r => r.json())
    .then(d => {
      setEnviandoEmail(null);
      if (d.ok) {
        alert(`✅ Email enviado correctamente`);
        // Refrescar log
        fetch(`https://qzsrl.velqo.io/api/actividad?lead_id=${lead.id}&limit=20`)
          .then(r => r.json())
          .then(data => setEmailLog(Array.isArray(data) ? data : []))
          .catch(() => {});
      } else {
        alert(`❌ Error al enviar: ${d.error}`);
      }
    })
    .catch(() => { setEnviandoEmail(null); alert("❌ Error de conexión"); });
  };

  const generarPDF = () => {
    if (!descPresupuesto || !montoNeto) return alert("Completá la descripción y el monto");
    setGenerando(true);
    fetch("https://qzsrl.velqo.io/api/presupuesto", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        empresa_key:     empKey,
        lead_id:         lead.id,
        descripcion:     descPresupuesto,
        monto_neto:      montoNum,
        vendedor_nombre: vendedor ? vendedor.nombre : "Equipo Comercial",
        vendedor_email:  "contacto@qzsrl.com.ar",
      }),
    })
    .then(r => r.json())
    .then(d => {
      setGenerando(false);
      if (d.ok) setPdfResult(d);
      else alert("Error: " + d.error);
    })
    .catch(() => { setGenerando(false); alert("Error al generar"); });
  };


  const pdfUrl     = pdfResult ? `https://qzsrl.velqo.io${pdfResult.url}` : "";
  const waMsg      = pdfResult ? encodeURIComponent(`Hola ${lead.contacto || lead.empresa}, le adjuntamos el presupuesto N° ${pdfResult.numero} por $${pdfResult.total.toLocaleString()}. Puede descargarlo aquí: ${pdfUrl}`) : "";
  const montoNum   = (() => { const n = parseFloat(String(montoNeto).replace(/[^0-9.]/g,"")); return isNaN(n) ? 0 : n; })();
  const iva        = montoNum > 0 ? Math.round(montoNum * 0.21 * 100) / 100 : 0;
  const total      = montoNum > 0 ? Math.round((montoNum + iva) * 100) / 100 : 0;
  const formatWATel = (tel) => {
    if (!tel) return "";
    let n = tel.replace(/[^0-9]/g, "");
    if (n.startsWith("0")) n = n.slice(1);
    if (n.startsWith("54")) return n;
    return "549" + n;
  };
  const waTel  = formatWATel(lead.tel);
  const waLink = waTel ? `https://wa.me/${waTel}?text=${waMsg}` : `https://wa.me/?text=${waMsg}`;

  return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(0,0,0,0.7)",
      display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:16,
    }}>
      <div style={{
        background:"#111827", border:"1px solid rgba(255,255,255,0.1)",
        borderRadius:16, padding:28, width:"100%", maxWidth:480, maxHeight:"90vh", overflowY:"auto",
      }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:20 }}>
          <div>
            <div style={{ fontSize:17, fontWeight:800, color:"#fff" }}>{lead.empresa}</div>
            <div style={{ fontSize:12, color:"rgba(255,255,255,0.4)", marginTop:2 }}>{lead.segmento} · {lead.region}</div>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.4)", cursor:"pointer", fontSize:20 }}>✕</button>
        </div>

        {[
          ["Contacto", lead.contacto],
          ["Cargo", lead.cargo],
          ["Email", lead.email],
          ["Teléfono", lead.tel],
          ["Ciudad", lead.ciudad],
          ["Fuente", lead.fuente],
          ["Fecha", lead.fecha],
          ["Notas", lead.notas],
          lead.monto ? ["Monto", fmt$(lead.monto)] : null,
        ].filter(Boolean).map(([k,v]) => v ? (
          <div key={k} style={{ display:"flex", gap:12, marginBottom:10 }}>
            <span style={{ fontSize:11, color:"rgba(255,255,255,0.35)", minWidth:70, textTransform:"uppercase", letterSpacing:.5, paddingTop:1 }}>{k}</span>
            <span style={{ fontSize:13, color:"rgba(255,255,255,0.8)", flex:1 }}>{v}</span>
          </div>
        ) : null)}

        <div style={{ marginTop:8, marginBottom:16 }}>
          <span style={{ fontSize:11, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", letterSpacing:.5 }}>Score</span>
          <div style={{ marginTop:6 }}><ScoreBar score={lead.score}/></div>
        </div>

        {esAdmin && (
          <div>
            <label style={{ fontSize:11, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", letterSpacing:.5 }}>Asignar a vendedor</label>
            <select
              value={lead.vendedor || ""}
              onChange={e => onAsignar(lead.id, e.target.value)}
              style={{
                width:"100%", marginTop:6, background:"#1F2937",
                border:"1px solid rgba(255,255,255,0.12)", borderRadius:8,
                padding:"10px 14px", color:"#fff", fontSize:13, outline:"none", boxSizing:"border-box",
              }}
            >
              <option value="">Sin asignar</option>
              {vendedores.filter(v=>v.rol==="vendedor").map(v =>
                <option key={v.id} value={v.id}>{v.nombre}</option>
              )}
            </select>
          </div>
        )}

        {/* ── EMAILS ── */}
        <div style={{ marginTop:20, borderTop:"1px solid rgba(255,255,255,0.08)", paddingTop:16 }}>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", letterSpacing:.5, marginBottom:10 }}>
            Envío de emails
          </div>
          <div style={{ display:"flex", gap:8, marginBottom:14 }}>
            <button
              onClick={() => enviarEmail("presentacion")}
              disabled={!!enviandoEmail}
              style={{
                flex:1, padding:"9px 0", borderRadius:8, border:"none",
                background: enviandoEmail === "presentacion" ? "#374151" : "rgba(59,130,246,0.15)",
                color: enviandoEmail === "presentacion" ? "#9CA3AF" : "#3B82F6",
                fontWeight:700, fontSize:12, cursor: enviandoEmail ? "not-allowed" : "pointer",
              }}
            >
              {enviandoEmail === "presentacion" ? "⏳ Enviando..." : "📧 Enviar presentación"}
            </button>
            <button
              onClick={() => enviarEmail("5preguntas")}
              disabled={!!enviandoEmail}
              style={{
                flex:1, padding:"9px 0", borderRadius:8, border:"none",
                background: enviandoEmail === "5preguntas" ? "#374151" : "rgba(139,92,246,0.15)",
                color: enviandoEmail === "5preguntas" ? "#9CA3AF" : "#8B5CF6",
                fontWeight:700, fontSize:12, cursor: enviandoEmail ? "not-allowed" : "pointer",
              }}
            >
              {enviandoEmail === "5preguntas" ? "⏳ Enviando..." : "❓ Enviar 5 preguntas"}
            </button>
          </div>

          {/* Historial de emails de este lead */}
          {loadingLog && <div style={{ fontSize:11, color:"rgba(255,255,255,0.3)" }}>Cargando historial...</div>}
          {!loadingLog && emailLog.length > 0 && (
            <div>
              <div style={{ fontSize:10, color:"rgba(255,255,255,0.25)", marginBottom:6 }}>Historial de contacto</div>
              {emailLog.map(log => {
                const tipoLabel = { presentacion:"Presentación", "5preguntas":"5 Preguntas", presupuesto:"Presupuesto" }[log.tipo] || log.tipo;
                const fecha = new Date(log.creado_en).toLocaleString("es-AR", { day:"2-digit", month:"2-digit", hour:"2-digit", minute:"2-digit" });
                return (
                  <div key={log.id} style={{
                    display:"flex", justifyContent:"space-between", alignItems:"center",
                    padding:"5px 8px", borderRadius:6, marginBottom:4,
                    background: log.estado === "enviado" ? "rgba(16,185,129,0.07)" : "rgba(239,68,68,0.07)",
                    border:`1px solid ${log.estado === "enviado" ? "rgba(16,185,129,0.15)" : "rgba(239,68,68,0.15)"}`,
                  }}>
                    <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                      <span style={{ fontSize:10, color: log.estado === "enviado" ? "#10B981" : "#EF4444" }}>
                        {log.estado === "enviado" ? "✓" : "✗"}
                      </span>
                      <span style={{ fontSize:11, color:"rgba(255,255,255,0.65)" }}>{tipoLabel}</span>
                      {log.enviado_por && log.enviado_por !== "sistema" && (
                        <span style={{ fontSize:9, color:"rgba(255,255,255,0.3)" }}>· {log.enviado_por}</span>
                      )}
                    </div>
                    <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{fecha}</span>
                  </div>
                );
              })}
            </div>
          )}
          {!loadingLog && emailLog.length === 0 && (
            <div style={{ fontSize:11, color:"rgba(255,255,255,0.2)", textAlign:"center", padding:"6px 0" }}>
              Sin emails enviados aún
            </div>
          )}
        </div>

        {/* ── PRESUPUESTO ── */}
        <div style={{ marginTop:20, borderTop:"1px solid rgba(255,255,255,0.08)", paddingTop:16 }}>
          <button onClick={() => { setMostrarPresupuesto(!mostrarPresupuesto); setPdfResult(null); }} style={{
            width:"100%", padding:"10px", borderRadius:8, border:"none",
            background: mostrarPresupuesto ? "rgba(255,107,0,0.2)" : "rgba(255,107,0,0.1)",
            color:"#FF6B00", fontWeight:700, fontSize:13, cursor:"pointer",
          }}>
            📄 {mostrarPresupuesto ? "Cerrar presupuesto" : "Generar presupuesto"}
          </button>

          {mostrarPresupuesto && !pdfResult && (
            <div style={{ marginTop:14 }}>
              <div style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", letterSpacing:.5, display:"block", marginBottom:6 }}>
                  Descripción del servicio
                </label>
                <textarea
                  value={descPresupuesto}
                  onChange={e => setDescPresupuesto(e.target.value)}
                  placeholder="Ej: Limpieza técnica de campanas extractoras y ductos de grasa. Incluye desmontaje, limpieza química, desinfección y certificado digital."
                  rows={4}
                  style={{
                    width:"100%", background:"#1F2937", border:"1px solid rgba(255,255,255,0.12)",
                    borderRadius:8, padding:"10px 12px", color:"#fff", fontSize:12,
                    outline:"none", resize:"vertical", boxSizing:"border-box",
                  }}
                />
              </div>

              <div style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", letterSpacing:.5, display:"block", marginBottom:6 }}>
                  Monto neto (sin IVA)
                </label>
                <input
                  type="text"
                  value={montoNeto}
                  onChange={e => setMontoNeto(e.target.value)}
                  placeholder="Ej: 45000"
                  style={{
                    width:"100%", background:"#1F2937", border:"1px solid rgba(255,255,255,0.12)",
                    borderRadius:8, padding:"10px 12px", color:"#fff", fontSize:13,
                    outline:"none", boxSizing:"border-box",
                  }}
                />
              </div>

              {montoNum > 0 && (
                <div style={{ background:"rgba(255,107,0,0.08)", border:"1px solid rgba(255,107,0,0.2)", borderRadius:8, padding:"10px 14px", marginBottom:14 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"rgba(255,255,255,0.5)", marginBottom:4 }}>
                    <span>Subtotal</span><span>${montoNum.toLocaleString()}</span>
                  </div>
                  <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"rgba(255,255,255,0.5)", marginBottom:6 }}>
                    <span>IVA 21%</span><span>${iva.toLocaleString()}</span>
                  </div>
                  <div style={{ display:"flex", justifyContent:"space-between", fontSize:14, fontWeight:800, color:"#FF6B00", borderTop:"1px solid rgba(255,107,0,0.2)", paddingTop:6 }}>
                    <span>TOTAL</span><span>${total.toLocaleString()}</span>
                  </div>
                </div>
              )}

              <button onClick={generarPDF} disabled={generando} style={{
                width:"100%", padding:"12px", borderRadius:8, border:"none",
                background: generando ? "#374151" : "#FF6B00",
                color: generando ? "#9CA3AF" : "#0F0A00",
                fontWeight:700, fontSize:13, cursor: generando ? "not-allowed" : "pointer",
              }}>
                {generando ? "⏳ Generando PDF..." : "📄 Generar PDF"}
              </button>
            </div>
          )}

          {pdfResult && (
            <div style={{ marginTop:14 }}>
              <div style={{ background:"rgba(16,185,129,0.1)", border:"1px solid rgba(16,185,129,0.3)", borderRadius:8, padding:"12px 14px", marginBottom:12, textAlign:"center" }}>
                <div style={{ fontSize:13, fontWeight:700, color:"#10B981", marginBottom:2 }}>✅ Presupuesto generado</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)" }}>N° {pdfResult.numero} · Total ${pdfResult.total?.toLocaleString()}</div>
              </div>

              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <a href={pdfUrl} target="_blank" rel="noreferrer" style={{
                  display:"block", textAlign:"center", padding:"10px", borderRadius:8,
                  background:"rgba(255,255,255,0.08)", color:"#fff", textDecoration:"none",
                  fontSize:13, fontWeight:600,
                }}>📥 Descargar PDF</a>

                <a href={`mailto:${lead.email}?subject=Presupuesto N° ${pdfResult.numero} — QZ SRL&body=Estimado ${lead.contacto || lead.empresa},%0D%0A%0D%0AAdjuntamos el presupuesto solicitado.%0D%0ADescargue el PDF aquí: ${pdfUrl}%0D%0A%0D%0ASaludos,%0D%0AEquipo QZ SRL`} style={{
                  display:"block", textAlign:"center", padding:"10px", borderRadius:8,
                  background:"rgba(59,130,246,0.15)", color:"#3B82F6", textDecoration:"none",
                  fontSize:13, fontWeight:600,
                }}>📧 Enviar por email</a>

                <a href={waLink} target="_blank" rel="noreferrer" style={{
                  display:"block", textAlign:"center", padding:"10px", borderRadius:8,
                  background:"rgba(37,211,102,0.15)", color:"#25D366", textDecoration:"none",
                  fontSize:13, fontWeight:600,
                }}>💬 Enviar por WhatsApp</a>

                <button onClick={() => { setPdfResult(null); setDescPresupuesto(""); setMontoNeto(""); }} style={{
                  padding:"8px", borderRadius:8, border:"1px solid rgba(255,255,255,0.1)",
                  background:"transparent", color:"rgba(255,255,255,0.4)", cursor:"pointer", fontSize:12,
                }}>Nuevo presupuesto</button>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

// ── CARD LEAD ────────────────────────────────────────────────────
function LeadCard({ lead, columnaColor, onDragStart, onTap, esAdmin, vendedores }) {
  const vendedor = vendedores.find(v => v.id === lead.vendedor);
  return (
    <div
      draggable
      onDragStart={e => onDragStart(e, lead.id)}
      onClick={() => onTap(lead)}
      style={{
        background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)",
        borderLeft:`3px solid ${columnaColor}`, borderRadius:10, padding:"12px 14px",
        cursor:"grab", marginBottom:8, transition:"transform .15s, box-shadow .15s",
        userSelect:"none",
      }}
      onMouseEnter={e => { e.currentTarget.style.transform="translateY(-1px)"; e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,0.3)"; }}
      onMouseLeave={e => { e.currentTarget.style.transform=""; e.currentTarget.style.boxShadow=""; }}
    >
      <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4 }}>
        {(() => {
          const empColors = {
            "QZ SRL":      { bg:"rgba(255,107,0,0.15)",  color:"#FF6B00" },
            "QZ Low Cost": { bg:"rgba(245,158,11,0.15)", color:"#F59E0B" },
            "Air Quality": { bg:"rgba(6,182,212,0.15)",  color:"#06B6D4" },
          };
          const ec = empColors[lead.empresa_captio] || { bg:"rgba(139,92,246,0.15)", color:"#8B5CF6" };
          return (
            <span style={{
              fontSize:9, fontWeight:700, padding:"2px 8px", borderRadius:10,
              background:ec.bg, color:ec.color, whiteSpace:"nowrap",
            }}>{lead.empresa_captio || "QZ SRL"}</span>
          );
        })()}
      </div>
      <div style={{ fontSize:13, fontWeight:700, color:"#fff", marginBottom:2, lineHeight:1.3 }}>{lead.empresa}</div>
      <div style={{ fontSize:11, color:"rgba(255,255,255,0.45)", marginBottom:8 }}>{lead.contacto} · {lead.cargo}</div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
        <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{FUENTE_ICON[lead.fuente] || "📌"} {lead.fuente}</span>
        <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{lead.region}</span>
      </div>
      <ScoreBar score={lead.score}/>
      {lead.monto > 0 && (
        <div style={{ marginTop:6, fontSize:12, fontWeight:700, color:"#F59E0B" }}>{fmt$(lead.monto)}</div>
      )}
      {esAdmin && vendedor && (
        <div style={{ marginTop:6, fontSize:10, color:"rgba(255,255,255,0.3)" }}>👤 {vendedor.nombre}</div>
      )}
    </div>
  );
}

// ── COLUMNA KANBAN ───────────────────────────────────────────────
function Columna({ col, leads, onDrop, onDragOver, onDragStart, onTap, esAdmin, vendedores }) {
  const total$ = leads.filter(l=>l.monto>0).reduce((a,b)=>a+b.monto,0);
  return (
    <div
      style={{ flex:1, minWidth:0 }}
      onDragOver={onDragOver}
      onDrop={e => onDrop(e, col.id)}
    >
      <div style={{
        background: col.bg, border:`1px solid ${col.color}33`,
        borderRadius:12, padding:"10px 12px", marginBottom:8,
        display:"flex", justifyContent:"space-between", alignItems:"center",
      }}>
        <div>
          <span style={{ fontSize:12, fontWeight:700, color:col.color }}>{col.label}</span>
          <span style={{ fontSize:11, color:"rgba(255,255,255,0.35)", marginLeft:8 }}>{leads.length}</span>
        </div>
        {total$ > 0 && <span style={{ fontSize:11, fontWeight:700, color:col.color }}>{fmt$(total$)}</span>}
      </div>
      <div style={{ minHeight:120 }}>
        {leads.map(lead => (
          <LeadCard
            key={lead.id}
            lead={lead}
            columnaColor={col.color}
            onDragStart={onDragStart}
            onTap={onTap}
            esAdmin={esAdmin}
            vendedores={vendedores}
          />
        ))}
      </div>
    </div>
  );
}

// ── LOGIN ────────────────────────────────────────────────────────
function Login({ vendedores, onLogin }) {
  const [sel, setSel] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");

  const entrar = () => {
    const v = vendedores.find(x => x.id === sel && x.pin === pin);
    if (v) { onLogin(v); }
    else { setError("PIN incorrecto"); setPin(""); }
  };

  return (
    <div style={{
      minHeight:"100vh", background:"#0F0F0F", display:"flex",
      alignItems:"center", justifyContent:"center", padding:24,
      fontFamily:"'DM Sans','Segoe UI',sans-serif",
    }}>
      <div style={{
        background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)",
        borderRadius:20, padding:36, width:"100%", maxWidth:380, textAlign:"center",
      }}>
        <div style={{
          width:52, height:52, borderRadius:14, margin:"0 auto 20px",
          background:"linear-gradient(135deg,#FF6B00,#CC4400)",
          display:"flex", alignItems:"center", justifyContent:"center",
          fontWeight:900, fontSize:20, color:"#fff",
        }}>QZ</div>
        <div style={{ fontSize:20, fontWeight:800, color:"#fff", marginBottom:4 }}>QZ SRL — CRM</div>
        <div style={{ fontSize:13, color:"rgba(255,255,255,0.35)", marginBottom:28 }}>Ingresá con tu usuario y PIN</div>

        <select
          value={sel}
          onChange={e => { setSel(e.target.value); setError(""); }}
          style={{
            width:"100%", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)",
            borderRadius:10, padding:"11px 14px", color:sel?"#fff":"rgba(255,255,255,0.35)",
            fontSize:13, outline:"none", marginBottom:12, boxSizing:"border-box",
          }}
        >
          <option value="">Seleccionar usuario...</option>
          {vendedores.map(v => <option key={v.id} value={v.id} style={{background:"#1a2234"}}>{v.nombre}</option>)}
        </select>

        <input
          type="password"
          value={pin}
          onChange={e => { setPin(e.target.value); setError(""); }}
          onKeyDown={e => e.key === "Enter" && entrar()}
          placeholder="PIN de 4 dígitos"
          maxLength={4}
          style={{
            width:"100%", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.1)",
            borderRadius:10, padding:"11px 14px", color:"#fff", fontSize:16,
            outline:"none", marginBottom:8, boxSizing:"border-box", textAlign:"center", letterSpacing:8,
          }}
        />

        {error && <div style={{ fontSize:12, color:"#EF4444", marginBottom:8 }}>{error}</div>}

        <button
          onClick={entrar}
          disabled={!sel || pin.length < 4}
          style={{
            width:"100%", padding:"12px 0", borderRadius:10, border:"none",
            background:"linear-gradient(135deg,#FF6B00,#CC4400)",
            color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer",
            opacity:(!sel || pin.length < 4) ? 0.4 : 1, marginTop:4,
          }}
        >Ingresar</button>
      </div>
    </div>
  );
}

// ── PANEL ADMIN — Agente ─────────────────────────────────────────
function PanelAgente({ regiones, onAgregarRegion }) {
  const [cfg, setCfg] = useState({ segmento:"construcción", ciudad:"Córdoba", radio:"40" });
  const [corriendo, setCorriendo] = useState(false);
  const [logs, setLogs] = useState([]);
  const [nuevaRegion, setNuevaRegion] = useState("");
  const logRef = useRef(null);

  const pasos = [
    `🔎 Iniciando agente — segmento: "${cfg.segmento}"`,
    `📍 Radio: ${cfg.radio} km desde ${cfg.ciudad}`,
    `📋 Páginas Amarillas → buscando...`,
    `   ✅ 6 empresas encontradas`,
    `📋 Guía Oleo → buscando...`,
    `   ✅ 4 empresas encontradas`,
    `📋 Cylex → buscando...`,
    `   ✅ 3 empresas encontradas`,
    `🔍 SerpAPI → buscando...`,
    `   ✅ 5 empresas encontradas`,
    `🤖 Groq → calificando 18 empresas únicas...`,
    `   ⭐ "Constructora Roca SRL" → score 89`,
    `   ⭐ "Metalúrgica Norte SA" → score 84`,
    `   ⚠️  "Talleres Express" → score 52 (descartado)`,
    `   ⭐ "Ingeniería Sur SRL" → score 77`,
    `💾 4 leads nuevos guardados`,
    `✅ Agente finalizado`,
  ];

  const ejecutar = () => {
    setCorriendo(true); setLogs([]);
    let i = 0;
    const iv = setInterval(() => {
      if (i < pasos.length) {
        setLogs(p => [...p, { t: new Date().toLocaleTimeString("es-AR"), m: pasos[i] }]);
        i++;
        setTimeout(() => { if (logRef.current) logRef.current.scrollTop = 9999; }, 30);
      } else {
        clearInterval(iv);
        setCorriendo(false);
      }
    }, 650);
  };

  return (
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20 }}>
      {/* Config agente */}
      <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
        <div style={{ fontWeight:700, fontSize:14, color:"#fff", marginBottom:16 }}>⚙️ Configurar búsqueda</div>
        {[
          { label:"Segmento / Rubro", key:"segmento", placeholder:"ej: construcción" },
          { label:"Ciudad base",      key:"ciudad",   placeholder:"ej: Córdoba" },
          { label:"Radio (km)",       key:"radio",    placeholder:"ej: 40" },
        ].map(f => (
          <div key={f.key} style={{ marginBottom:12 }}>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", letterSpacing:1, marginBottom:4 }}>{f.label}</div>
            <input
              value={cfg[f.key]}
              onChange={e => setCfg(p => ({...p,[f.key]:e.target.value}))}
              placeholder={f.placeholder}
              style={{
                width:"100%", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.09)",
                borderRadius:8, padding:"9px 12px", color:"#fff", fontSize:13, outline:"none", boxSizing:"border-box",
              }}
            />
          </div>
        ))}
        <button
          onClick={ejecutar}
          disabled={corriendo}
          style={{
            width:"100%", padding:"11px 0", borderRadius:9, border:"none",
            background: corriendo ? "rgba(255,107,0,0.2)" : "linear-gradient(135deg,#FF6B00,#CC4400)",
            color:"#fff", fontWeight:700, fontSize:13, cursor: corriendo ? "not-allowed" : "pointer",
          }}
        >{corriendo ? "⏳ Ejecutando..." : "▶ Ejecutar Agente"}</button>

        {logs.length > 0 && (
          <div ref={logRef} style={{
            marginTop:14, background:"rgba(0,0,0,0.4)", borderRadius:8, padding:12,
            fontFamily:"monospace", fontSize:11, maxHeight:160, overflowY:"auto",
          }}>
            {logs.map((l,i) => (
              <div key={i} style={{ color:"rgba(255,255,255,0.65)", marginBottom:3, display:"flex", gap:8 }}>
                <span style={{ color:"rgba(255,255,255,0.2)", minWidth:64 }}>{l.t}</span>
                <span>{l.m}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Regiones */}
      <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
        <div style={{ fontWeight:700, fontSize:14, color:"#fff", marginBottom:16 }}>🗺️ Regiones activas</div>
        {regiones.map(r => (
          <div key={r} style={{
            display:"flex", alignItems:"center", gap:8, padding:"8px 12px",
            background:"rgba(255,107,0,0.08)", border:"1px solid rgba(255,107,0,0.2)",
            borderRadius:8, marginBottom:8,
          }}>
            <div style={{ width:6, height:6, borderRadius:"50%", background:"#FF6B00" }}/>
            <span style={{ fontSize:13, color:"rgba(255,255,255,0.8)" }}>{r}</span>
          </div>
        ))}
        <div style={{ display:"flex", gap:8, marginTop:12 }}>
          <input
            value={nuevaRegion}
            onChange={e => setNuevaRegion(e.target.value)}
            placeholder="Nueva región..."
            onKeyDown={e => {
              if (e.key==="Enter" && nuevaRegion.trim()) {
                onAgregarRegion(nuevaRegion.trim());
                setNuevaRegion("");
              }
            }}
            style={{
              flex:1, background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.09)",
              borderRadius:8, padding:"8px 12px", color:"#fff", fontSize:13, outline:"none",
            }}
          />
          <button
            onClick={() => { if(nuevaRegion.trim()) { onAgregarRegion(nuevaRegion.trim()); setNuevaRegion(""); }}}
            style={{
              padding:"8px 14px", borderRadius:8, border:"none",
              background:"rgba(59,130,246,0.2)", color:"#FF6B00", cursor:"pointer", fontWeight:700,
            }}
          >+</button>
        </div>
      </div>
    </div>
  );
}

// ── KNOWLEDGE VIEWER ──────────────────────────────────────────────
function KnowledgeViewer({ empresa }) {
  const [data, setData] = useState({ texto:"", chars:0 });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://qzsrl.velqo.io/api/knowledge/${empresa}`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [empresa]);

  const limpiar = () => {
    if (!window.confirm("¿Borrar todo el conocimiento de esta empresa?")) return;
    fetch(`https://qzsrl.velqo.io/api/knowledge/${empresa}/clear`, { method:"POST" })
      .then(() => setData({ texto:"", chars:0 }))
      .catch(() => {});
  };

  return (
    <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
        <div>
          <div style={{ fontWeight:700, fontSize:13, color:"#fff" }}>Conocimiento actual</div>
          <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginTop:2 }}>
            {data.chars > 0 ? `${data.chars} caracteres cargados` : "Sin conocimiento cargado aún"}
          </div>
        </div>
        {data.chars > 0 && (
          <button onClick={limpiar} style={{
            padding:"5px 12px", borderRadius:7, border:"1px solid rgba(239,68,68,0.3)",
            background:"rgba(239,68,68,0.08)", color:"#EF4444", fontSize:11, cursor:"pointer",
          }}>🗑 Limpiar</button>
        )}
      </div>
      {loading && <div style={{ fontSize:12, color:"rgba(255,255,255,0.3)" }}>Cargando...</div>}
      {!loading && data.chars === 0 && (
        <div style={{ fontSize:12, color:"rgba(255,255,255,0.2)", textAlign:"center", padding:"20px 0" }}>
          No hay conocimiento cargado. Subí un archivo arriba para empezar.
        </div>
      )}
      {!loading && data.chars > 0 && (
        <textarea
          readOnly
          value={data.texto}
          style={{
            width:"100%", height:200, background:"rgba(0,0,0,0.3)",
            border:"1px solid rgba(255,255,255,0.08)", borderRadius:8,
            padding:"10px 12px", color:"rgba(255,255,255,0.6)", fontSize:11,
            resize:"vertical", outline:"none", fontFamily:"monospace",
          }}
        />
      )}
    </div>
  );
}

// ── TAB ACTIVIDAD ────────────────────────────────────────────────
function TabActividad({ leads, esAdmin }) {
  const [logs, setLogs]           = useState([]);
  const [loading, setLoading]     = useState(false);
  const [filtroEmp, setFiltroEmp] = useState("todas");
  const [filtroTipo, setFiltroTipo] = useState("todos");

  const cargar = () => {
    setLoading(true);
    let url = "https://qzsrl.velqo.io/api/actividad?limit=100";
    if (filtroEmp !== "todas") url += `&empresa=${filtroEmp}`;
    fetch(url)
      .then(r => r.json())
      .then(data => { setLogs(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, [filtroEmp]);

  const logsFiltrados = filtroTipo === "todos" ? logs : logs.filter(l => l.tipo === filtroTipo);

  const tipoLabel  = { presentacion:"Presentación", "5preguntas":"5 Preguntas", presupuesto:"Presupuesto", minerva_ok:"Minerva ✓", minerva_vendedor:"Minerva → Vendedor" };
  const tipoColor  = { presentacion:"#3B82F6", "5preguntas":"#8B5CF6", presupuesto:"#F59E0B", minerva_ok:"#10B981", minerva_vendedor:"#FF6B00" };
  const empColor   = { qzsrl:"#FF6B00", lowcost:"#F59E0B", airquality:"#06B6D4" };
  const empLabel   = { qzsrl:"QZ SRL", lowcost:"QZ Low Cost", airquality:"Air Quality" };

  return (
    <div>
      {/* Filtros */}
      <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap", alignItems:"center" }}>
        <div style={{ fontSize:15, fontWeight:800, color:"#fff", flex:1 }}>⚡ Actividad del sistema</div>
        <select value={filtroEmp} onChange={e => setFiltroEmp(e.target.value)} style={{
          background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)",
          borderRadius:8, padding:"7px 12px", color:"#fff", fontSize:12, outline:"none",
        }}>
          <option value="todas">Todas las empresas</option>
          <option value="qzsrl">QZ SRL</option>
          <option value="lowcost">QZ Low Cost</option>
          <option value="airquality">Air Quality</option>
        </select>
        <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)} style={{
          background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)",
          borderRadius:8, padding:"7px 12px", color:"#fff", fontSize:12, outline:"none",
        }}>
          <option value="todos">Todos los tipos</option>
          <option value="presentacion">Presentación</option>
          <option value="5preguntas">5 Preguntas</option>
          <option value="presupuesto">Presupuesto</option>
          <option value="minerva_ok">Minerva ✓</option>
          <option value="minerva_vendedor">Minerva → Vendedor</option>
        </select>
        <button onClick={cargar} style={{
          padding:"7px 14px", borderRadius:8, border:"1px solid rgba(255,255,255,0.1)",
          background:"transparent", color:"rgba(255,255,255,0.5)", cursor:"pointer", fontSize:12,
        }}>↻ Actualizar</button>
      </div>

      {/* Tabla de actividad */}
      {loading && <div style={{ fontSize:13, color:"rgba(255,255,255,0.3)", textAlign:"center", padding:40 }}>Cargando...</div>}
      {!loading && logsFiltrados.length === 0 && (
        <div style={{ fontSize:13, color:"rgba(255,255,255,0.2)", textAlign:"center", padding:60 }}>
          Sin actividad registrada aún
        </div>
      )}
      {!loading && logsFiltrados.length > 0 && (
        <div style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, overflow:"hidden" }}>
          {logsFiltrados.map((log, i) => {
            const lead = leads.find(l => String(l.id) === String(log.lead_id));
            const fecha = new Date(log.creado_en).toLocaleString("es-AR", {
              day:"2-digit", month:"2-digit", year:"2-digit", hour:"2-digit", minute:"2-digit"
            });
            return (
              <div key={log.id} style={{
                display:"flex", alignItems:"center", gap:12, padding:"11px 16px",
                borderBottom: i < logsFiltrados.length-1 ? "1px solid rgba(255,255,255,0.05)" : "none",
              }}>
                {/* Estado */}
                <span style={{ fontSize:14, minWidth:16 }}>{log.estado === "enviado" ? "✅" : "❌"}</span>

                {/* Tipo */}
                <span style={{
                  fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:10, whiteSpace:"nowrap",
                  background:`${tipoColor[log.tipo] || "#6B7280"}20`,
                  color: tipoColor[log.tipo] || "#6B7280",
                }}>
                  {tipoLabel[log.tipo] || log.tipo}
                </span>

                {/* Empresa captio */}
                <span style={{
                  fontSize:9, fontWeight:700, padding:"2px 7px", borderRadius:10, whiteSpace:"nowrap",
                  background:`${empColor[log.empresa] || "#6B7280"}20`,
                  color: empColor[log.empresa] || "#6B7280",
                }}>
                  {empLabel[log.empresa] || log.empresa}
                </span>

                {/* Lead */}
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:12, color:"#fff", fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                    {lead?.empresa || `Lead #${log.lead_id}`}
                  </div>
                  <div style={{ fontSize:10, color:"rgba(255,255,255,0.35)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                    {log.destinatario}
                  </div>
                </div>

                {/* Enviado por */}
                {log.enviado_por && (
                  <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)", whiteSpace:"nowrap" }}>
                    👤 {log.enviado_por}
                  </span>
                )}

                {/* Fecha */}
                <span style={{ fontSize:10, color:"rgba(255,255,255,0.25)", whiteSpace:"nowrap" }}>{fecha}</span>
              </div>
            );
          })}
        </div>
      )}

      {/* KPIs rápidos */}
      {!loading && logs.length > 0 && (
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))", gap:10, marginTop:16 }}>
          {[
            { label:"Total enviados",     value: logs.filter(l=>l.estado==="enviado").length, color:"#10B981" },
            { label:"Presentaciones",     value: logs.filter(l=>l.tipo==="presentacion").length, color:"#3B82F6" },
            { label:"5 Preguntas",        value: logs.filter(l=>l.tipo==="5preguntas").length, color:"#8B5CF6" },
            { label:"Errores",            value: logs.filter(l=>l.estado==="error").length, color:"#EF4444" },
          ].map(k => (
            <div key={k.label} style={{
              background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)",
              borderRadius:10, padding:"12px 14px",
            }}>
              <div style={{ fontSize:22, fontWeight:900, color:k.color }}>{k.value}</div>
              <div style={{ fontSize:10, color:"rgba(255,255,255,0.4)", marginTop:4 }}>{k.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── APP PRINCIPAL ────────────────────────────────────────────────
export default function App() {
  // ── Estados (TODOS primero) ──────────────────────────────────
  const [usuario, setUsuario]           = useLocalStorage("qz_usuario", null);
  const [leads, setLeads]               = useLocalStorage("qz_leads", LEADS_DEMO);
  const [regiones, setRegiones]         = useLocalStorage("qz_regiones", REGIONES_INICIALES);
  const [tab, setTab]                   = useState("dashboard");
  const [filtroEmpresa, setFiltroEmpresa]     = useState("Todas");
  const [filtroRegion, setFiltroRegion]       = useState("Todas");
  const [filtroSegmento, setFiltroSegmento]   = useState("Todos");
  const [filtroVendedor, setFiltroVendedor]   = useState("Todos");
  const [busqueda, setBusqueda]         = useState("");
  const [dragId, setDragId]             = useState(null);
  const [modal, setModal]               = useState(null);
  const [configs, setConfigs]           = useState({});
  const [configEmpresa, setConfigEmpresa]     = useState("qzsrl");
  const [configEditando, setConfigEditando]   = useState(null);
  const [pendientes, setPendientes]     = useState({});
  const [sysStatus, setSysStatus]       = useState(null);

  // ── Constantes ───────────────────────────────────────────────
  const vendedores = VENDEDORES;
  const esAdmin = usuario?.rol === "admin";

  // ── Hooks de datos ───────────────────────────────────────────
  useLeadsFromFile(setLeads);

  useEffect(() => {
    if (!esAdmin) return;
    const empresas = ["qzsrl", "lowcost", "airquality"];
    empresas.forEach(emp => {
      fetch(`https://qzsrl.velqo.io/api/config/${emp}`)
        .then(r => r.json())
        .then(data => setConfigs(prev => ({ ...prev, [emp]: data })))
        .catch(() => {});
      fetch(`https://qzsrl.velqo.io/api/pendientes/${emp}`)
        .then(r => r.json())
        .then(data => setPendientes(prev => ({ ...prev, [emp]: data.pendientes || 0 })))
        .catch(() => {});
    });
  }, [esAdmin]);

  useEffect(() => {
    const fetchStatus = () => {
      fetch("https://qzsrl.velqo.io/api/status")
        .then(r => r.json())
        .then(data => setSysStatus(data))
        .catch(() => {});
    };
    fetchStatus();
    const iv = setInterval(fetchStatus, 2 * 60 * 1000);
    return () => clearInterval(iv);
  }, []);

  // Filtrar leads según rol y filtros
  const leadsFiltrados = leads.filter(l => {
    if (!esAdmin && l.vendedor !== usuario?.id) return false;
    if (filtroEmpresa !== "Todas" && l.empresa_captio !== filtroEmpresa) return false;
    if (filtroRegion !== "Todas" && l.region !== filtroRegion) return false;
    if (filtroSegmento !== "Todos" && l.segmento !== filtroSegmento) return false;
    if (filtroVendedor !== "Todos" && l.vendedor !== filtroVendedor) return false;
    if (busqueda) {
      const q = busqueda.toLowerCase();
      return l.empresa.toLowerCase().includes(q) || l.contacto.toLowerCase().includes(q);
    }
    return true;
  });

  // KPIs
  const pipeline    = leads.filter(l=>l.estado==="Cotizado").reduce((a,b)=>a+b.monto,0);
  const ganado      = leads.filter(l=>l.estado==="Ganado").reduce((a,b)=>a+b.monto,0);
  const totalCerr   = leads.filter(l=>l.estado==="Ganado"||l.estado==="Perdido").length;
  const tasaCierre  = totalCerr ? Math.round(leads.filter(l=>l.estado==="Ganado").length/totalCerr*100) : 0;
  const nuevosHoy   = leads.filter(l=>l.fecha===new Date().toISOString().split("T")[0]).length;
  const leadsGanados = leads.filter(l=>l.estado==="Ganado"&&l.monto>0);
  const valorPromedio = leadsGanados.length ? Math.round(leadsGanados.reduce((a,b)=>a+b.monto,0)/leadsGanados.length) : 0;
  const leadsValidados = leads.filter(l=>l.estado==="Validado").length;

  // Drag & Drop
  const handleDragStart = useCallback((e, id) => {
    setDragId(id);
    e.dataTransfer.effectAllowed = "move";
  }, []);

  const handleDragOver = useCallback(e => { e.preventDefault(); e.dataTransfer.dropEffect = "move"; }, []);

  const handleDrop = useCallback((e, colId) => {
    e.preventDefault();
    if (!dragId) return;
    const lead = leads.find(l => l.id === dragId);
    if (!lead || lead.estado === colId) { setDragId(null); return; }
    setModal({ tipo:"mover", lead, destino:colId });
    setDragId(null);
  }, [dragId, leads]);

  const confirmarMover = ({ monto, motivo }) => {
    const { lead, destino } = modal;
    const nuevosLeads = leads.map(l =>
      l.id === lead.id
        ? { ...l, estado:destino, monto: monto || l.monto, notas: motivo ? `Perdido: ${motivo}` : l.notas }
        : l
    );
    setLeads(nuevosLeads);
    // Persistir en el servidor
    fetch("https://qzsrl.velqo.io/api/leads", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(nuevosLeads.map(l => ({
        ...l,
        cargo_decisor: l.cargo,
        email_estimado: l.email,
        telefono: l.tel,
      })))
    }).catch(() => {});
    setModal(null);
  };

  const asignarVendedor = (leadId, vendedorId) => {
    setLeads(prev => prev.map(l => l.id===leadId ? {...l, vendedor:vendedorId} : l));
  };

  // Segmentos únicos
  const segmentos = ["Todos", ...Array.from(new Set(leads.map(l=>l.segmento).filter(Boolean)))];

  if (!usuario) return <Login vendedores={vendedores} onLogin={setUsuario}/>;

  const tabs = [
    { id:"dashboard",  label:"📊 Dashboard" },
    { id:"kanban",     label:"🗂 Pipeline" },
    { id:"actividad",  label:"⚡ Actividad" },
    { id:"conocimiento", label:"🧠 Conocimiento" },
    ...(esAdmin ? [
      { id:"config",  label:"🎯 Configuración" },
      { id:"admin",   label:"⚙️ Admin" },
    ] : []),
  ];

  return (
    <div style={{ minHeight:"100vh", background:"#0F0F0F", fontFamily:"'DM Sans','Segoe UI',sans-serif", color:"#fff" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;800;900&display=swap');
        *{box-sizing:border-box} ::-webkit-scrollbar{width:4px;height:4px}
        ::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.1);border-radius:2px}
        select option{background:#1a2234}
        @media(max-width:640px){.kanban-grid{flex-direction:column!important}}
      `}</style>

      {/* HEADER */}
      <div style={{
        height:56, padding:"0 20px", borderBottom:"1px solid rgba(255,255,255,0.06)",
        display:"flex", alignItems:"center", justifyContent:"space-between",
        background:"rgba(15,15,15,0.97)", position:"sticky", top:0, zIndex:50,
      }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{
            width:32, height:32, borderRadius:9,
            background:"linear-gradient(135deg,#FF6B00,#CC4400)",
            display:"flex", alignItems:"center", justifyContent:"center",
            fontWeight:900, fontSize:13, color:"#fff",
          }}>QZ</div>
          <span style={{ fontWeight:800, fontSize:14, color:"#fff" }}>CRM</span>
          {nuevosHoy > 0 && (
            <span style={{ fontSize:10, fontWeight:700, background:"rgba(239,68,68,0.2)", color:"#EF4444", padding:"2px 8px", borderRadius:20 }}>
              +{nuevosHoy} hoy
            </span>
          )}
        </div>

        <div style={{ display:"flex", gap:2 }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              padding:"5px 14px", borderRadius:7, border:"none",
              background: tab===t.id ? "rgba(255,107,0,0.15)" : "transparent",
              color: tab===t.id ? "#FF6B00" : "rgba(255,255,255,0.4)",
              fontWeight: tab===t.id ? 700 : 500, fontSize:12, cursor:"pointer",
            }}>{t.label}</button>
          ))}
        </div>

        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:11, color:"rgba(255,255,255,0.35)" }}>{usuario.nombre}</span>
          <button onClick={() => setUsuario(null)} style={{
            padding:"4px 10px", borderRadius:6, border:"1px solid rgba(255,255,255,0.08)",
            background:"transparent", color:"rgba(255,255,255,0.35)", cursor:"pointer", fontSize:11,
          }}>Salir</button>
        </div>
      </div>

      <div style={{ padding:"20px 16px", maxWidth:1400, margin:"0 auto" }}>

        {/* ── ACTIVIDAD ── */}
        {tab === "actividad" && (
          <TabActividad leads={leads} esAdmin={esAdmin} />
        )}

        {/* ── KANBAN ── */}
        {tab === "kanban" && (
          <>
            {/* Filtros */}
            <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
              <input
                value={busqueda}
                onChange={e=>setBusqueda(e.target.value)}
                placeholder="🔍 Buscar empresa..."
                style={{
                  flex:1, minWidth:160, background:"rgba(255,255,255,0.05)",
                  border:"1px solid rgba(255,255,255,0.08)", borderRadius:8,
                  padding:"8px 12px", color:"#fff", fontSize:12, outline:"none",
                }}
              />
              {[
                { val:filtroEmpresa,   set:setFiltroEmpresa,   opts:EMPRESAS_CAPTIO,          label:"Empresa" },
                { val:filtroRegion,    set:setFiltroRegion,    opts:["Todas",...regiones,"Otros"], label:"Región" },
                { val:filtroSegmento,  set:setFiltroSegmento,  opts:segmentos,                label:"Rubro"  },
                ...(esAdmin ? [{ val:filtroVendedor, set:setFiltroVendedor, opts:["Todos",...vendedores.filter(v=>v.rol==="vendedor").map(v=>v.id)], label:"Vendedor" }] : []),
              ].map(f => (
                <select key={f.label} value={f.val} onChange={e=>f.set(e.target.value)} style={{
                  background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)",
                  borderRadius:8, padding:"8px 12px", color:"#fff", fontSize:12, outline:"none",
                }}>
                  {f.opts.map(o => (
                    <option key={o} value={o}>
                      {f.label==="Vendedor" ? (vendedores.find(v=>v.id===o)?.nombre || "Todos") : o}
                    </option>
                  ))}
                </select>
              ))}
            </div>

            {/* Columnas kanban */}
            <div className="kanban-grid" style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
              {COLUMNAS.map(col => (
                <Columna
                  key={col.id}
                  col={col}
                  leads={leadsFiltrados.filter(l=>l.estado===col.id)}
                  onDragStart={handleDragStart}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onTap={lead => setModal({ tipo:"detalle", lead })}
                  esAdmin={esAdmin}
                  vendedores={vendedores}
                />
              ))}
            </div>
          </>
        )}

        {/* ── DASHBOARD NASA ── */}
        {tab === "dashboard" && (
          <div>
            {/* Fila 1 — KPIs grandes */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:10, marginBottom:20 }}>
              {[
                { icon:"🆕", label:"Leads totales",    value:leads.length,          color:"#8B5CF6", sub:"en el sistema" },
                { icon:"✅", label:"Validados",         value:leadsValidados,        color:"#3B82F6", sub:"con interés confirmado" },
                { icon:"💬", label:"Cotizados",         value:leads.filter(l=>l.estado==="Cotizado").length, color:"#F59E0B", sub:"esperando respuesta" },
                { icon:"🏆", label:"Ganados",           value:leads.filter(l=>l.estado==="Ganado").length,  color:"#10B981", sub:"cierres exitosos" },
                { icon:"💰", label:"Pipeline $",        value:fmt$(pipeline),        color:"#F59E0B", sub:"en cotizaciones" },
                { icon:"📈", label:"Closing rate",      value:`${tasaCierre}%`,      color:"#FF6B00", sub:"tasa de cierre" },
                { icon:"⭐", label:"Valor promedio",    value:fmt$(valorPromedio),   color:"#10B981", sub:"por operación ganada" },
                { icon:"🔥", label:"Nuevos hoy",        value:nuevosHoy,             color:"#EF4444", sub:"leads del día" },
              ].map(k => (
                <div key={k.label} style={{
                  background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)",
                  borderRadius:12, padding:"14px 16px", position:"relative", overflow:"hidden",
                }}>
                  <div style={{ position:"absolute", top:8, right:10, fontSize:20, opacity:0.15 }}>{k.icon}</div>
                  <div style={{ fontSize:24, fontWeight:900, color:k.color, lineHeight:1 }}>{k.value}</div>
                  <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.7)", marginTop:6 }}>{k.label}</div>
                  <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginTop:2 }}>{k.sub}</div>
                </div>
              ))}
            </div>

            {/* Fila 2 — Gráficos */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:14 }}>

              {/* Pipeline por empresa */}
              <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:18 }}>
                <div style={{ fontWeight:700, fontSize:13, marginBottom:4, color:"#fff" }}>Pipeline por empresa</div>
                <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginBottom:14 }}>Leads activos por proyecto</div>
                {["QZ SRL","QZ Low Cost","Air Quality"].map((emp, ei) => {
                  const cols = ["#FF6B00","#F59E0B","#06B6D4"];
                  const eLeads = leads.filter(l=>l.empresa_captio===emp);
                  const ePct = leads.length ? Math.round(eLeads.length/leads.length*100) : 0;
                  const eMonto = eLeads.filter(l=>l.monto>0).reduce((a,b)=>a+b.monto,0);
                  return (
                    <div key={emp} style={{ marginBottom:14 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                        <span style={{ fontSize:12, color:"rgba(255,255,255,0.7)", fontWeight:500 }}>{emp}</span>
                        <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                          {eMonto>0 && <span style={{ fontSize:10, color:cols[ei], fontWeight:700 }}>{fmt$(eMonto)}</span>}
                          <span style={{ fontSize:11, fontWeight:700, color:cols[ei] }}>{eLeads.length} leads</span>
                        </div>
                      </div>
                      <div style={{ height:6, background:"rgba(255,255,255,0.06)", borderRadius:3 }}>
                        <div style={{ height:"100%", width:`${Math.max(ePct,2)}%`, background:cols[ei], borderRadius:3, transition:"width 0.5s" }}/>
                      </div>
                      <div style={{ display:"flex", gap:6, marginTop:5 }}>
                        {["Nuevo","Validado","Cotizado","Ganado"].map(est => {
                          const n = eLeads.filter(l=>l.estado===est).length;
                          if (!n) return null;
                          const estCol = {Nuevo:"#6B7280",Validado:"#3B82F6",Cotizado:"#F59E0B",Ganado:"#10B981"}[est];
                          return <span key={est} style={{ fontSize:9, color:estCol, background:`${estCol}20`, padding:"1px 6px", borderRadius:10 }}>{est}: {n}</span>;
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Leads por ciudad */}
              <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:18 }}>
                <div style={{ fontWeight:700, fontSize:13, marginBottom:4, color:"#fff" }}>Leads por ciudad</div>
                <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginBottom:14 }}>Distribución geográfica</div>
                {(() => {
                  const ciudades = ["CABA","Córdoba","Rosario","Mendoza","Santa Fe"];
                  const cols = ["#8B5CF6","#FF6B00","#06B6D4","#10B981","#F59E0B"];
                  const otrosLeads = leads.filter(l=>!ciudades.some(c=>l.region===c||l.ciudad?.includes(c)));
                  const items = [
                    ...ciudades.map((ciudad,ci) => ({
                      label: ciudad,
                      n: leads.filter(l=>l.region===ciudad||l.ciudad?.includes(ciudad)).length,
                      color: cols[ci],
                    })),
                    { label:"Otros", n: otrosLeads.length, color:"#4B5563" },
                  ].filter(x=>x.n>0);
                  const max = Math.max(...items.map(x=>x.n), 1);
                  return items.map(({ label, n, color }) => (
                    <div key={label} style={{ marginBottom:10 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                        <span style={{ fontSize:12, color:"rgba(255,255,255,0.65)" }}>{label}</span>
                        <span style={{ fontSize:12, fontWeight:700, color }}>{n}</span>
                      </div>
                      <div style={{ height:6, background:"rgba(255,255,255,0.06)", borderRadius:3 }}>
                        <div style={{ height:"100%", width:`${Math.round(n/max*100)}%`, background:color, borderRadius:3, transition:"width 0.5s" }}/>
                      </div>
                    </div>
                  ));
                })()}
              </div>
            </div>

            {/* Fila 3 — Rankings */}
            <div style={{ display:"grid", gridTemplateColumns:esAdmin?"1fr 1fr 1fr":"1fr 1fr", gap:14 }}>

              {/* Por segmento/industria */}
              <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:18 }}>
                <div style={{ fontWeight:700, fontSize:13, marginBottom:4, color:"#fff" }}>Por segmento</div>
                <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginBottom:14 }}>Dónde está el negocio</div>
                {(() => {
                  const segs = Array.from(new Set(leads.map(l=>l.segmento).filter(Boolean)));
                  const segData = segs.map(s => ({
                    label: s,
                    total: leads.filter(l=>l.segmento===s).length,
                    ganados: leads.filter(l=>l.segmento===s&&l.estado==="Ganado").length,
                    monto: leads.filter(l=>l.segmento===s&&l.monto>0).reduce((a,b)=>a+b.monto,0),
                  })).sort((a,b)=>b.total-a.total).slice(0,6);
                  const max = Math.max(...segData.map(x=>x.total),1);
                  const segCols = ["#8B5CF6","#FF6B00","#06B6D4","#10B981","#F59E0B","#EF4444"];
                  return segData.map(({ label, total, ganados, monto },si) => (
                    <div key={label} style={{ marginBottom:12 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                        <span style={{ fontSize:11, color:"rgba(255,255,255,0.65)", maxWidth:110, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{label}</span>
                        <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                          {ganados>0 && <span style={{ fontSize:9, color:"#10B981" }}>✓{ganados}</span>}
                          {monto>0 && <span style={{ fontSize:9, color:"#F59E0B" }}>{fmt$(monto)}</span>}
                          <span style={{ fontSize:11, fontWeight:700, color:segCols[si%6] }}>{total}</span>
                        </div>
                      </div>
                      <div style={{ height:5, background:"rgba(255,255,255,0.06)", borderRadius:2 }}>
                        <div style={{ height:"100%", width:`${Math.round(total/max*100)}%`, background:segCols[si%6], borderRadius:2 }}/>
                      </div>
                    </div>
                  ));
                })()}
              </div>

              {/* Top leads por score */}
              <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:18 }}>
                <div style={{ fontWeight:700, fontSize:13, marginBottom:4, color:"#fff" }}>Top leads por score</div>
                <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginBottom:14 }}>Las mejores oportunidades</div>
                {[...leads].filter(l=>l.estado==="Nuevo"||l.estado==="Validado").sort((a,b)=>b.score-a.score).slice(0,6).map(l => (
                  <div key={l.id} style={{
                    display:"flex", alignItems:"center", gap:10, padding:"8px 10px",
                    background:"rgba(255,255,255,0.03)", borderRadius:8, marginBottom:6,
                    cursor:"pointer",
                  }} onClick={() => setModal({ tipo:"detalle", lead:l })}>
                    <div style={{
                      width:32, height:32, borderRadius:8, background:`${scoreColor(l.score)}20`,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontSize:12, fontWeight:900, color:scoreColor(l.score), flexShrink:0,
                    }}>{l.score}</div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:12, fontWeight:600, color:"#fff", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{l.empresa}</div>
                      <div style={{ fontSize:10, color:"rgba(255,255,255,0.35)" }}>{l.ciudad} · {l.segmento}</div>
                    </div>
                    <span style={{ fontSize:9, padding:"2px 7px", borderRadius:10, background:`${COLUMNAS.find(c=>c.id===l.estado)?.color}20`, color:COLUMNAS.find(c=>c.id===l.estado)?.color, flexShrink:0 }}>{l.estado}</span>
                  </div>
                ))}
              </div>

              {/* Ranking vendedores — solo admin */}
              {esAdmin && (
                <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:18 }}>
                  <div style={{ fontWeight:700, fontSize:13, marginBottom:4, color:"#fff" }}>Ranking vendedores</div>
                  <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginBottom:14 }}>Rendimiento del equipo</div>
                  {vendedores.filter(v=>v.rol==="vendedor").map((v,i) => {
                    const vLeads   = leads.filter(l=>l.vendedor===v.id);
                    const vGanados = vLeads.filter(l=>l.estado==="Ganado");
                    const vMonto   = vGanados.reduce((a,b)=>a+b.monto,0);
                    const vRate    = vLeads.filter(l=>l.estado==="Ganado"||l.estado==="Perdido").length
                      ? Math.round(vGanados.length/vLeads.filter(l=>l.estado==="Ganado"||l.estado==="Perdido").length*100) : 0;
                    const medal = ["🥇","🥈","🥉"][i] || "·";
                    return (
                      <div key={v.id} style={{
                        padding:"12px 14px", background:"rgba(255,255,255,0.03)",
                        borderRadius:10, marginBottom:10,
                        border: i===0 ? "1px solid rgba(255,107,0,0.3)" : "1px solid transparent",
                      }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                          <span style={{ fontSize:18 }}>{medal}</span>
                          <div style={{ flex:1 }}>
                            <div style={{ fontSize:13, fontWeight:700, color:"#fff" }}>{v.nombre}</div>
                            <div style={{ fontSize:10, color:"rgba(255,255,255,0.35)" }}>{vLeads.length} leads · {vRate}% cierre</div>
                          </div>
                          <div style={{ fontSize:14, fontWeight:800, color:"#10B981" }}>{fmt$(vMonto)}</div>
                        </div>
                        <div style={{ display:"flex", gap:6 }}>
                          {["Nuevo","Validado","Cotizado","Ganado","Perdido"].map(est => {
                            const n = vLeads.filter(l=>l.estado===est).length;
                            if(!n) return null;
                            const ec = {Nuevo:"#6B7280",Validado:"#3B82F6",Cotizado:"#F59E0B",Ganado:"#10B981",Perdido:"#EF4444"}[est];
                            return <span key={est} style={{ fontSize:9, color:ec, background:`${ec}15`, padding:"2px 7px", borderRadius:10 }}>{est[0]}: {n}</span>;
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── CONFIGURACIÓN ── */}
        {tab === "config" && esAdmin && (
          <div>
            <div style={{ marginBottom:20 }}>
              <div style={{ fontWeight:800, fontSize:18, color:"#fff", marginBottom:4 }}>Configuración de agentes</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.35)" }}>Ajustá segmentos, regiones y parámetros de búsqueda por empresa</div>
            </div>

            {/* Selector empresa */}
            <div style={{ display:"flex", gap:8, marginBottom:20 }}>
              {[
                { key:"qzsrl",      label:"QZ SRL",      color:"#FF6B00" },
                { key:"lowcost",    label:"QZ Low Cost",  color:"#F59E0B" },
                { key:"airquality", label:"Air Quality",  color:"#06B6D4" },
              ].map(e => (
                <button key={e.key} onClick={() => { setConfigEmpresa(e.key); setConfigEditando(null); }} style={{
                  padding:"8px 18px", borderRadius:8, border:"none", cursor:"pointer",
                  background: configEmpresa===e.key ? e.color : "rgba(255,255,255,0.05)",
                  color: configEmpresa===e.key ? "#0F0A00" : "rgba(255,255,255,0.5)",
                  fontWeight: configEmpresa===e.key ? 700 : 400, fontSize:13,
                }}>{e.label}</button>
              ))}
            </div>

            {configs[configEmpresa] && (() => {
              const cfg = configEditando || configs[configEmpresa];
              const pend = pendientes[configEmpresa] || 0;
              const empColor = {qzsrl:"#FF6B00",lowcost:"#F59E0B",airquality:"#06B6D4"}[configEmpresa];

              const guardarConfig = () => {
                fetch(`https://qzsrl.velqo.io/api/config/${configEmpresa}`, {
                  method:"POST",
                  headers:{"Content-Type":"application/json"},
                  body: JSON.stringify(cfg, null, 2),
                }).then(() => {
                  setConfigs(prev => ({ ...prev, [configEmpresa]: cfg }));
                  setConfigEditando(null);
                  alert("✅ Configuración guardada");
                }).catch(() => alert("❌ Error al guardar"));
              };

              return (
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>

                  {/* Info general */}
                  <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:16 }}>Información general</div>

                    <div style={{ marginBottom:12 }}>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginBottom:4 }}>Leads pendientes de calificar</div>
                      <div style={{ fontSize:22, fontWeight:800, color: pend>0 ? empColor : "#6B7280" }}>{pend}</div>
                    </div>

                    <div style={{ marginBottom:12 }}>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginBottom:6 }}>Score mínimo para aprobar lead</div>
                      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                        <input type="range" min="0" max="100" value={cfg.score_minimo||65}
                          onChange={e => setConfigEditando({ ...cfg, score_minimo: parseInt(e.target.value) })}
                          style={{ flex:1 }}
                        />
                        <span style={{ fontSize:16, fontWeight:700, color:empColor, minWidth:32 }}>{cfg.score_minimo||65}</span>
                      </div>
                    </div>

                    <div style={{ marginBottom:12 }}>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginBottom:6 }}>Decisor objetivo</div>
                      <textarea
                        value={cfg.decisor||""}
                        onChange={e => setConfigEditando({ ...cfg, decisor: e.target.value })}
                        style={{
                          width:"100%", background:"rgba(255,255,255,0.05)",
                          border:"1px solid rgba(255,255,255,0.1)", borderRadius:8,
                          padding:"8px 12px", color:"#fff", fontSize:12,
                          resize:"vertical", minHeight:60, outline:"none",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom:16 }}>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginBottom:6 }}>Descripción del servicio</div>
                      <textarea
                        value={cfg.servicio||""}
                        onChange={e => setConfigEditando({ ...cfg, servicio: e.target.value })}
                        style={{
                          width:"100%", background:"rgba(255,255,255,0.05)",
                          border:"1px solid rgba(255,255,255,0.1)", borderRadius:8,
                          padding:"8px 12px", color:"#fff", fontSize:12,
                          resize:"vertical", minHeight:60, outline:"none",
                        }}
                      />
                    </div>

                    {configEditando && (
                      <div style={{ display:"flex", gap:8 }}>
                        <button onClick={guardarConfig} style={{
                          flex:1, padding:"10px", borderRadius:8, border:"none",
                          background:empColor, color:"#0F0A00", fontWeight:700, cursor:"pointer", fontSize:13,
                        }}>💾 Guardar cambios</button>
                        <button onClick={() => setConfigEditando(null)} style={{
                          padding:"10px 16px", borderRadius:8, border:"1px solid rgba(255,255,255,0.15)",
                          background:"transparent", color:"rgba(255,255,255,0.5)", cursor:"pointer", fontSize:13,
                        }}>Cancelar</button>
                      </div>
                    )}
                  </div>

                  {/* Segmentos y regiones */}
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>

                    {/* Segmentos */}
                    <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                      <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:12 }}>
                        Segmentos activos
                        <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginLeft:8 }}>El agente rota entre ellos cada día</span>
                      </div>
                      {(cfg.segmentos||[]).map((seg, si) => (
                        <div key={si} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
                          <div style={{ width:6, height:6, borderRadius:"50%", background:empColor, flexShrink:0 }}/>
                          <input
                            value={seg}
                            onChange={e => {
                              const segs = [...(cfg.segmentos||[])];
                              segs[si] = e.target.value;
                              setConfigEditando({ ...cfg, segmentos: segs });
                            }}
                            style={{
                              flex:1, background:"rgba(255,255,255,0.04)",
                              border:"1px solid rgba(255,255,255,0.08)", borderRadius:6,
                              padding:"5px 10px", color:"#fff", fontSize:12, outline:"none",
                            }}
                          />
                          <button onClick={() => {
                            const segs = (cfg.segmentos||[]).filter((_,i)=>i!==si);
                            setConfigEditando({ ...cfg, segmentos: segs });
                          }} style={{ background:"none", border:"none", color:"#EF4444", cursor:"pointer", fontSize:16 }}>×</button>
                        </div>
                      ))}
                      <button onClick={() => setConfigEditando({ ...cfg, segmentos: [...(cfg.segmentos||[]), ""] })}
                        style={{
                          marginTop:8, padding:"6px 14px", borderRadius:6,
                          border:`1px solid ${empColor}40`, background:`${empColor}10`,
                          color:empColor, cursor:"pointer", fontSize:12, fontWeight:600,
                        }}>+ Agregar segmento</button>
                    </div>

                    {/* Regiones */}
                    <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                      <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:12 }}>Regiones activas</div>
                      {["Buenos Aires","Rosario","Córdoba","Mendoza","Santa Fe"].map(reg => {
                        const activa = (cfg.regiones||[]).includes(reg);
                        return (
                          <div key={reg} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid rgba(255,255,255,0.05)" }}>
                            <span style={{ fontSize:13, color: activa ? "#fff" : "rgba(255,255,255,0.3)" }}>{reg}</span>
                            <button onClick={() => {
                              const regs = activa
                                ? (cfg.regiones||[]).filter(r=>r!==reg)
                                : [...(cfg.regiones||[]), reg];
                              setConfigEditando({ ...cfg, regiones: regs });
                            }} style={{
                              padding:"4px 12px", borderRadius:20, border:"none", cursor:"pointer", fontSize:11, fontWeight:600,
                              background: activa ? `${empColor}20` : "rgba(255,255,255,0.05)",
                              color: activa ? empColor : "rgba(255,255,255,0.3)",
                            }}>{activa ? "✓ Activa" : "Inactiva"}</button>
                          </div>
                        );
                      })}
                    </div>

                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* ── STATUS SISTEMA ── */}
        {tab === "dashboard" && sysStatus && (
          <div style={{ marginTop:14, background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:18 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <div style={{
                  width:8, height:8, borderRadius:"50%",
                  background: Object.values(sysStatus.procesos).every(p=>p.ok) ? "#10B981" : "#F59E0B",
                  boxShadow: "0 0 6px " + (Object.values(sysStatus.procesos).every(p=>p.ok) ? "#10B981" : "#F59E0B"),
                }}/>
                <span style={{ fontWeight:700, fontSize:13, color:"#fff" }}>
                  {Object.values(sysStatus.procesos).every(p=>p.ok) ? "Sistema operativo" : "Sistema con advertencias"}
                </span>
              </div>
              {sysStatus.ultima_actualizacion && (
                <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>
                  Ultima actualizacion: {sysStatus.ultima_actualizacion}
                </span>
              )}
            </div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {Object.entries(sysStatus.procesos).map(([nombre, estado]) => (
                <div key={nombre} style={{
                  display:"flex", alignItems:"center", gap:6, padding:"5px 12px", borderRadius:20,
                  background: estado.ok ? "rgba(16,185,129,0.1)" : "rgba(245,158,11,0.1)",
                  border: "1px solid " + (estado.ok ? "rgba(16,185,129,0.2)" : "rgba(245,158,11,0.2)"),
                }}>
                  <span style={{ fontSize:10 }}>{estado.ok ? "✅" : "⚠️"}</span>
                  <span style={{ fontSize:11, color: estado.ok ? "#10B981" : "#F59E0B", fontWeight:600 }}>{nombre}</span>
                  {!estado.ok && estado.error && (
                    <span style={{ fontSize:9, color:"rgba(255,255,255,0.35)", maxWidth:120, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {estado.error.replace(/[^a-zA-Z0-9 ]/g,"").trim().slice(0,40)}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── CONOCIMIENTO ── */}
        {tab === "conocimiento" && esAdmin && (
          <div style={{ maxWidth:750, margin:"0 auto" }}>
            <div style={{ marginBottom:20 }}>
              <div style={{ fontWeight:800, fontSize:18, color:"#fff", marginBottom:4 }}>🧠 Base de conocimiento</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.35)" }}>Los archivos que subas alimentan a DeepSeek para calificar mejor los leads y personalizar los emails</div>
            </div>

            {/* Selector empresa */}
            <div style={{ display:"flex", gap:8, marginBottom:20 }}>
              {[
                { key:"qzsrl",      label:"QZ SRL",      color:"#FF6B00" },
                { key:"lowcost",    label:"QZ Low Cost",  color:"#F59E0B" },
                { key:"airquality", label:"Air Quality",  color:"#06B6D4" },
              ].map(e => (
                <button key={e.key} onClick={() => setConfigEmpresa(e.key)} style={{
                  padding:"8px 18px", borderRadius:8, border:"none", cursor:"pointer",
                  background: configEmpresa===e.key ? e.color : "rgba(255,255,255,0.05)",
                  color: configEmpresa===e.key ? "#0F0A00" : "rgba(255,255,255,0.5)",
                  fontWeight: configEmpresa===e.key ? 700 : 400, fontSize:13,
                }}>{e.label}</button>
              ))}
            </div>

            {/* Upload de archivos */}
            <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20, marginBottom:14 }}>
              <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:14 }}>Subir documento</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.4)", marginBottom:14 }}>
                Formatos soportados: PDF, Word (.docx), Excel (.xlsx), texto (.txt)
              </div>
              {[
                { icon:"📋", label:"Protocolo CRM",       desc:"Cómo se trabaja cada oportunidad" },
                { icon:"💰", label:"Lista de precios",     desc:"Precios por tipo de cliente y servicio" },
                { icon:"❓", label:"Objeciones frecuentes",desc:"Cómo responder las más comunes" },
                { icon:"🏢", label:"Perfil de empresa",    desc:"Quiénes somos, certificaciones, años" },
              ].map(item => (
                <div key={item.label} style={{
                  display:"flex", alignItems:"center", gap:14, padding:"12px 14px",
                  background:"rgba(255,255,255,0.03)", borderRadius:10,
                  border:"1px solid rgba(255,255,255,0.06)", marginBottom:8,
                }}>
                  <span style={{ fontSize:20 }}>{item.icon}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:"#fff" }}>{item.label}</div>
                    <div style={{ fontSize:11, color:"rgba(255,255,255,0.35)" }}>{item.desc}</div>
                  </div>
                  <label style={{
                    padding:"6px 14px", borderRadius:7, border:"1px solid rgba(255,107,0,0.3)",
                    background:"rgba(255,107,0,0.08)", color:"#FF6B00", fontSize:11,
                    cursor:"pointer", fontWeight:600,
                  }}>
                    Subir archivo
                    <input type="file" accept=".pdf,.docx,.xlsx,.txt,.csv" style={{ display:"none" }}
                      onChange={e => {
                        const file = e.target.files[0];
                        if (!file) return;
                        const reader = new FileReader();
                        reader.onload = ev => {
                          const body = ev.target.result;
                          fetch(`https://qzsrl.velqo.io/api/knowledge/${configEmpresa}`, {
                            method:"POST",
                            headers:{
                              "Content-Type": "application/octet-stream",
                              "X-Filename": file.name,
                            },
                            body,
                          })
                          .then(r => r.json())
                          .then(d => {
                            if (d.ok) alert(`✅ "${file.name}" procesado correctamente`);
                            else alert(`❌ Error: ${d.error}`);
                          })
                          .catch(() => alert("❌ Error al subir el archivo"));
                        };
                        reader.readAsArrayBuffer(file);
                        e.target.value = "";
                      }}
                    />
                  </label>
                </div>
              ))}
            </div>

            {/* Vista del knowledge actual */}
            <KnowledgeViewer empresa={configEmpresa} />
          </div>
        )}

        {/* ── ADMIN ── */}
        {tab === "admin" && esAdmin && (
          <div>
            <div style={{ marginBottom:20 }}>
              <div style={{ fontWeight:800, fontSize:18, color:"#fff", marginBottom:4 }}>Panel de Control</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.35)" }}>Análisis visual del pipeline completo</div>
            </div>

            {/* Fila 1 — Pie charts */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:16, marginBottom:16 }}>

              {/* Pipeline por empresa */}
              {(() => {
                const empresas = ["QZ SRL","QZ Low Cost","Air Quality"];
                const cols = ["#FF6B00","#F59E0B","#06B6D4"];
                const data = empresas.map((e,i) => ({
                  label: e, color: cols[i],
                  total: leads.filter(l=>l.empresa_captio===e).length,
                  monto: leads.filter(l=>l.empresa_captio===e&&l.monto>0).reduce((a,b)=>a+b.monto,0),
                }));
                const totalLeads = data.reduce((a,b)=>a+b.total,0) || 1;
                return (
                  <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:16 }}>Pipeline por empresa</div>
                    <div style={{ display:"flex", justifyContent:"center", marginBottom:16 }}>
                      <svg width="140" height="140" viewBox="0 0 140 140">
                        {(() => {
                          let angle = -Math.PI/2;
                          return data.map((d,i) => {
                            const pct = d.total/totalLeads;
                            const endAngle = angle + pct*2*Math.PI;
                            const x1 = 70 + 60*Math.cos(angle), y1 = 70 + 60*Math.sin(angle);
                            const x2 = 70 + 60*Math.cos(endAngle), y2 = 70 + 60*Math.sin(endAngle);
                            const large = pct > 0.5 ? 1 : 0;
                            const path = pct > 0.999 
                              ? `M70,10 A60,60 0 1,1 69.99,10 Z`
                              : `M70,70 L${x1},${y1} A60,60 0 ${large},1 ${x2},${y2} Z`;
                            const el = <path key={i} d={path} fill={d.color} opacity={0.85}/>;
                            angle = endAngle;
                            return el;
                          });
                        })()}
                        <circle cx="70" cy="70" r="35" fill="#0F0F0F"/>
                        <text x="70" y="66" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="bold">{totalLeads}</text>
                        <text x="70" y="80" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="9">leads</text>
                      </svg>
                    </div>
                    {data.map(d => (
                      <div key={d.label} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                        <div style={{ width:10, height:10, borderRadius:"50%", background:d.color, flexShrink:0 }}/>
                        <span style={{ fontSize:12, color:"rgba(255,255,255,0.65)", flex:1 }}>{d.label}</span>
                        <span style={{ fontSize:12, fontWeight:700, color:d.color }}>{d.total}</span>
                        {d.monto>0 && <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{fmt$(d.monto)}</span>}
                      </div>
                    ))}
                  </div>
                );
              })()}

              {/* Estado del pipeline */}
              {(() => {
                const estados = [
                  { id:"Nuevo",    color:"#6B7280" },
                  { id:"Validado", color:"#3B82F6" },
                  { id:"Cotizado", color:"#F59E0B" },
                  { id:"Ganado",   color:"#10B981" },
                  { id:"Perdido",  color:"#EF4444" },
                ];
                const data = estados.map(e => ({
                  ...e,
                  total: leads.filter(l=>l.estado===e.id).length,
                  monto: leads.filter(l=>l.estado===e.id&&l.monto>0).reduce((a,b)=>a+b.monto,0),
                })).filter(d=>d.total>0);
                const totalLeads = data.reduce((a,b)=>a+b.total,0) || 1;
                return (
                  <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:16 }}>Estado del pipeline</div>
                    <div style={{ display:"flex", justifyContent:"center", marginBottom:16 }}>
                      <svg width="140" height="140" viewBox="0 0 140 140">
                        {(() => {
                          let angle = -Math.PI/2;
                          return data.map((d,i) => {
                            const pct = d.total/totalLeads;
                            const endAngle = angle + pct*2*Math.PI;
                            const x1 = 70 + 60*Math.cos(angle), y1 = 70 + 60*Math.sin(angle);
                            const x2 = 70 + 60*Math.cos(endAngle), y2 = 70 + 60*Math.sin(endAngle);
                            const large = pct > 0.5 ? 1 : 0;
                            const path = pct > 0.999
                              ? `M70,10 A60,60 0 1,1 69.99,10 Z`
                              : `M70,70 L${x1},${y1} A60,60 0 ${large},1 ${x2},${y2} Z`;
                            const el = <path key={i} d={path} fill={d.color} opacity={0.85}/>;
                            angle = endAngle;
                            return el;
                          });
                        })()}
                        <circle cx="70" cy="70" r="35" fill="#0F0F0F"/>
                        <text x="70" y="66" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="bold">{leads.filter(l=>l.estado==="Ganado").length}</text>
                        <text x="70" y="80" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="9">ganados</text>
                      </svg>
                    </div>
                    {data.map(d => (
                      <div key={d.id} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                        <div style={{ width:10, height:10, borderRadius:"50%", background:d.color, flexShrink:0 }}/>
                        <span style={{ fontSize:12, color:"rgba(255,255,255,0.65)", flex:1 }}>{d.id}</span>
                        <span style={{ fontSize:12, fontWeight:700, color:d.color }}>{d.total}</span>
                        {d.monto>0 && <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{fmt$(d.monto)}</span>}
                      </div>
                    ))}
                  </div>
                );
              })()}

              {/* Leads por región */}
              {(() => {
                const ciudades = ["CABA","Córdoba","Rosario","Mendoza","Santa Fe"];
                const cols = ["#8B5CF6","#FF6B00","#06B6D4","#10B981","#F59E0B","#4B5563"];
                const data = [
                  ...ciudades.map((c,i) => ({
                    label: c, color: cols[i],
                    total: leads.filter(l=>l.region===c||l.ciudad?.includes(c)).length,
                  })),
                  { label:"Otros", color:"#4B5563", total: leads.filter(l=>!ciudades.some(c=>l.region===c||l.ciudad?.includes(c))).length },
                ].filter(d=>d.total>0);
                const totalLeads = data.reduce((a,b)=>a+b.total,0) || 1;
                return (
                  <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:16 }}>Leads por región</div>
                    <div style={{ display:"flex", justifyContent:"center", marginBottom:16 }}>
                      <svg width="140" height="140" viewBox="0 0 140 140">
                        {(() => {
                          let angle = -Math.PI/2;
                          return data.map((d,i) => {
                            const pct = d.total/totalLeads;
                            const endAngle = angle + pct*2*Math.PI;
                            const x1 = 70 + 60*Math.cos(angle), y1 = 70 + 60*Math.sin(angle);
                            const x2 = 70 + 60*Math.cos(endAngle), y2 = 70 + 60*Math.sin(endAngle);
                            const large = pct > 0.5 ? 1 : 0;
                            const path = pct > 0.999
                              ? `M70,10 A60,60 0 1,1 69.99,10 Z`
                              : `M70,70 L${x1},${y1} A60,60 0 ${large},1 ${x2},${y2} Z`;
                            const el = <path key={i} d={path} fill={d.color} opacity={0.85}/>;
                            angle = endAngle;
                            return el;
                          });
                        })()}
                        <circle cx="70" cy="70" r="35" fill="#0F0F0F"/>
                        <text x="70" y="66" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="bold">{totalLeads}</text>
                        <text x="70" y="80" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="9">total</text>
                      </svg>
                    </div>
                    {data.map(d => (
                      <div key={d.label} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                        <div style={{ width:10, height:10, borderRadius:"50%", background:d.color, flexShrink:0 }}/>
                        <span style={{ fontSize:12, color:"rgba(255,255,255,0.65)", flex:1 }}>{d.label}</span>
                        <span style={{ fontSize:12, fontWeight:700, color:d.color }}>{d.total}</span>
                        <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)" }}>{Math.round(d.total/totalLeads*100)}%</span>
                      </div>
                    ))}
                  </div>
                );
              })()}

            </div>

            {/* Fila 2 — Segmentos + Cotizaciones */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>

              {/* Por segmento */}
              {(() => {
                const segs = Array.from(new Set(leads.map(l=>l.segmento).filter(Boolean)));
                const segCols = ["#8B5CF6","#FF6B00","#06B6D4","#10B981","#F59E0B","#EF4444","#3B82F6","#EC4899"];
                const data = segs.map((s,i) => ({
                  label: s, color: segCols[i%8],
                  total: leads.filter(l=>l.segmento===s).length,
                  ganados: leads.filter(l=>l.segmento===s&&l.estado==="Ganado").length,
                  monto: leads.filter(l=>l.segmento===s&&l.monto>0).reduce((a,b)=>a+b.monto,0),
                })).sort((a,b)=>b.total-a.total);
                const max = Math.max(...data.map(d=>d.total),1);
                return (
                  <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:16 }}>Leads por segmento / industria</div>
                    {data.map(d => (
                      <div key={d.label} style={{ marginBottom:12 }}>
                        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                          <span style={{ fontSize:12, color:"rgba(255,255,255,0.7)" }}>{d.label}</span>
                          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                            {d.ganados>0 && <span style={{ fontSize:10, color:"#10B981" }}>✓ {d.ganados} ganados</span>}
                            {d.monto>0 && <span style={{ fontSize:10, color:"#F59E0B" }}>{fmt$(d.monto)}</span>}
                            <span style={{ fontSize:12, fontWeight:700, color:d.color }}>{d.total}</span>
                          </div>
                        </div>
                        <div style={{ height:6, background:"rgba(255,255,255,0.06)", borderRadius:3 }}>
                          <div style={{ height:"100%", width:`${Math.round(d.total/max*100)}%`, background:d.color, borderRadius:3 }}/>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}

              {/* Cotizaciones por monto */}
              {(() => {
                const cotizados = leads.filter(l=>l.monto>0).sort((a,b)=>b.monto-a.monto).slice(0,8);
                const max = cotizados[0]?.monto || 1;
                const estCol = {Cotizado:"#F59E0B",Ganado:"#10B981",Perdido:"#EF4444"};
                return (
                  <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:14, padding:20 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:"#fff", marginBottom:4 }}>Top cotizaciones por monto</div>
                    <div style={{ fontSize:10, color:"rgba(255,255,255,0.3)", marginBottom:16 }}>
                      Total cotizado: {fmt$(leads.filter(l=>l.monto>0).reduce((a,b)=>a+b.monto,0))}
                    </div>
                    {cotizados.length === 0 && (
                      <div style={{ fontSize:12, color:"rgba(255,255,255,0.3)", textAlign:"center", padding:"20px 0" }}>
                        Aún no hay cotizaciones registradas
                      </div>
                    )}
                    {cotizados.map(l => (
                      <div key={l.id} style={{ marginBottom:12 }}>
                        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                          <span style={{ fontSize:11, color:"rgba(255,255,255,0.65)", maxWidth:160, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{l.empresa}</span>
                          <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                            <span style={{ fontSize:9, color:estCol[l.estado]||"#6B7280", background:`${estCol[l.estado]||"#6B7280"}20`, padding:"1px 6px", borderRadius:10 }}>{l.estado}</span>
                            <span style={{ fontSize:12, fontWeight:700, color:"#F59E0B" }}>{fmt$(l.monto)}</span>
                          </div>
                        </div>
                        <div style={{ height:5, background:"rgba(255,255,255,0.06)", borderRadius:2 }}>
                          <div style={{ height:"100%", width:`${Math.round(l.monto/max*100)}%`, background:estCol[l.estado]||"#6B7280", borderRadius:2 }}/>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}

            </div>
          </div>
        )}
      </div>

      {/* MODALES */}
      {modal?.tipo === "mover" && (
        <ModalMover
          lead={modal.lead}
          destino={modal.destino}
          onConfirm={confirmarMover}
          onCancel={() => setModal(null)}
        />
      )}
      {modal?.tipo === "detalle" && (
        <ModalDetalle
          lead={modal.lead}
          vendedores={vendedores}
          onClose={() => setModal(null)}
          onAsignar={asignarVendedor}
          esAdmin={esAdmin}
          usuarioActual={usuario}
        />
      )}
    </div>
  );
}
